export function cloneValue(value) {
  if (typeof structuredClone === "function") return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

export function setValueAtPath(source, path, value) {
  const next = cloneValue(source);
  const parts = String(path || "").split(".").filter(Boolean);
  if (!parts.length) return next;

  let cursor = next;
  parts.forEach((part, index) => {
    const isLast = index === parts.length - 1;
    const nextPart = parts[index + 1];
    const key = /^\d+$/.test(part) ? Number(part) : part;

    if (isLast) {
      cursor[key] = value;
      return;
    }

    const shouldBeArray = /^\d+$/.test(nextPart || "");
    if (cursor[key] == null || typeof cursor[key] !== "object") {
      cursor[key] = shouldBeArray ? [] : {};
    }
    cursor = cursor[key];
  });

  return next;
}

export function setManyValuesAtPaths(source, changes = {}) {
  return Object.entries(changes).reduce(
    (current, [path, value]) => setValueAtPath(current, path, value),
    source
  );
}
